module.exports = __webpack_public_path__ + "img/person-8.12a23a9.webp";